import { useState, useEffect } from "react";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { Button } from "./ui/button";
import { RichTextEditor } from "./RichTextEditor";
import { Pencil } from "lucide-react";

export const BehaviorDescriptionDialog = ({ strategy, behavior, open, onClose, onChange }) => {
  const [html, setHtml] = useState("");
  const [editing, setEditing] = useState(false);
  const [saving, setSaving] = useState(false);
  const has = !!(behavior?.description_html || "").replace(/<p><\/p>/g, "").trim();

  useEffect(() => {
    if (!open) return;
    setHtml(behavior?.description_html || "");
    setEditing(!has);
  }, [open]); // eslint-disable-line react-hooks/exhaustive-deps

  const save = async () => {
    setSaving(true);
    try {
      const { data } = await api.put(`/strategies/${strategy.id}/behaviors/${behavior.id}/description`, { html });
      onChange(data);
      toast.success("Beschrijving opgeslagen");
      setEditing(false);
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Opslaan mislukt");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="rounded-none max-w-4xl max-h-[90vh] overflow-y-auto" data-testid="behavior-description-dialog">
        <DialogHeader>
          <div className="font-mono text-[11px] uppercase tracking-widest text-zinc-500">{strategy.name} · gedrag</div>
          <DialogTitle className="font-grotesk text-2xl leading-tight">{behavior?.text}</DialogTitle>
          <DialogDescription>Uitgebreide beschrijving met tekst, afbeeldingen en YouTube-video's.</DialogDescription>
        </DialogHeader>
        {open && (editing ? (
          <RichTextEditor key="edit" value={html} onChange={setHtml} orgId={strategy.organization_id} />
        ) : (
          <div className="border-t border-zinc-200 pt-4">
            {has ? <RichTextEditor key="view" value={behavior.description_html} editable={false} /> : <p className="text-sm text-zinc-400">Nog geen beschrijving.</p>}
          </div>
        ))}
        <div className="flex justify-end gap-2">
          {editing ? (
            <>
              {has && <Button variant="outline" className="rounded-none" onClick={() => { setHtml(behavior.description_html); setEditing(false); }} data-testid="behavior-description-cancel-button">Annuleren</Button>}
              <Button className="rounded-none bg-zinc-900 hover:bg-zinc-700" onClick={save} disabled={saving} data-testid="behavior-description-save-button">{saving ? "Opslaan…" : "Opslaan"}</Button>
            </>
          ) : (
            <Button variant="outline" className="rounded-none" onClick={() => setEditing(true)} data-testid="behavior-description-edit-button"><Pencil className="h-4 w-4 mr-1" /> Bewerken</Button>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};
